import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character, 
  CreatureInstance, 
  DandDFeatureSource 
} from "@dndModels";
import { ModelBase } from "@models";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import { makeStyles } from "@utilities/theme_utilities";

import ButtonBox from "@components/input/buttons/ButtonBox";
import ToastBox from "@components/display/ToastBox";
import ExpandButton from "@components/input/buttons/ExpandButton";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import CheckBox from "@components/input/CheckBox";

interface Props { 
  char?: Character | CreatureInstance;
  data_type: string;
  model_base: ModelBase;
  variants: ModelBase[];
  getLinks?: boolean;
  onClick?: (obj: ModelBase) => void;
  disableObj?: (obj: ModelBase) => { disabled: boolean, reasons: string };
  detailFormat?: (obj: ModelBase) => React.ReactNode;
  values?: string[];
  onChange?: (changed: string[]) => void;
  show_image?: boolean;
  log_it?: boolean;
}

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function SelectObjectIndexRow({
  char,
  data_type,
  model_base,
  variants,
  getLinks = false,
  onClick,
  disableObj,
  detailFormat,
  values,
  onChange,
  show_image = false,
  log_it = false
}: Props) {
  const [expanded, setExpanded] = useState(false);
  const [description_for_id, setDescriptionForId] = useState("");
  const [toast_time, setToastTime] = useState(-1);
  const [ping, setPing] = useState(false);

  const genLink = (obj: ModelBase, type: string) => {
    navigator.clipboard.writeText(`[${type}:${obj.data_type};${obj.true_name}(${obj._id})]`);
    // navigator.clipboard.writeText(`[${type}:${obj.data_type};${obj._id}]`);
    setToastTime(common_util.get_time_number());
  }
  
  const useStyles = makeStyles()((theme) => {
    if (model_base instanceof DandDFeatureSource) {
      const colors = char_util.getColors({ char, user: api.user, for_id: model_base._id, source: model_base });
      return ({
        root: {
          backgroundColor: colors.backgroundColor,
          // border: "1px solid #777777",
          color: colors.color,
          // padding: "4px",
          // margin: "4px",
          // '&:hover': {
          //   backgroundColor: "Black",
          //   color: theme.palette.secondary.light
          // },
        }
      });
    } else {
      // console.log(theme);
      return ({
        root: {
          backgroundColor: theme.palette.secondary.main
        },
      });
    }
    // // console.log(theme);
    // return ({
    //   root: {
    //     backgroundColor: theme.palette.secondary.main
    //   },
    // });
  });

  const { classes, cx } = useStyles();

  const renderModelBase2 = ({ 
    disabled_reasons,
    // variant_reasons
  }: { 
    obj: ModelBase, 
    disabled_reasons: { disabled: boolean , reasons: string }
  }) => {
    let disabled = false;
    let reasons = "";
    disabled = disabled_reasons.disabled;
    reasons = disabled_reasons.reasons;

    const obj = model_base;
    const detail_format = obj.detail_format; // dt_info && dt_info.detail_format ? dt_info.detail_format : "";
    const description_format = obj.description_format;
    
    const detail = char_util.getStringWithReplacementsWithObject({ clean_me: detail_format, backup: "", obj });
    const description = char_util.getStringWithReplacementsWithObject({ clean_me: description_format, backup: obj.description, obj });

    if (onClick && !getLinks) {
      return (
        <Grid container spacing={0} direction="row" className={ disabled ? "padded grayBackground" : cx(classes.root, "padded") }>
          <Grid
            size={{
              xs: 12
            }}>
            <Grid container spacing={0} direction="row" className="whiteFont">
              <Grid
                container
                spacing={0}
                direction="row"
                className={ disabled ? "" : "clickable" }
                onClick={() => {
                  if (!disabled) {
                    onClick(obj);
                  }
                }}
                size={{
                  xs: 8
                }}>
                <Grid
                  size={{
                    xs: 6
                  }}>{ obj.name }</Grid>
                <Grid
                  size={{
                    xs: 6
                  }}>{ show_image && obj.image_url !== "" && <img src={ obj.image_url } alt={obj.name} style={{ maxHeight: "30px", maxWidth: "30px" }} /> }</Grid>
                { (reasons !== "" || detail !== "") &&
                  <Grid
                    size={{
                      xs: 12
                    }}><span className={ disabled ? "small_label whiteFont" : "small_label gray" }>{ detail }</span>&nbsp;<span className="small_label red">{ reasons }</span></Grid> 
                }
              </Grid>
              <Grid
                size={{
                  xs: 4
                }}>
                <ExpandButton
                  is_expanded={description_for_id === obj._id}
                  onClick={() => { setDescriptionForId(description_for_id === obj._id ? "" : obj._id); }}
                />
              </Grid>
            </Grid>
          </Grid>
          { description_for_id === obj._id &&
            <Grid
              style={{ border: "1px solid", backgroundColor: "black" }}
              size={{
                xs: 12
              }}>
              <DisplayStringWithReplacements display_string={description} />
            </Grid>
          }
        </Grid>
      );
    } else if (onClick) {
      return (
        <Grid container spacing={0} direction="row" className={ disabled ? "padded grayBackground" : cx(classes.root, "padded") }>
          <Grid
            size={{
              xs: 12
            }}>
            <Grid container spacing={0} direction="row" className="whiteFont">
              <Grid
                container
                spacing={0}
                direction="row"
                className={ disabled ? "" : "clickable" }
                onClick={() => {
                  if (!disabled) {
                    onClick(obj);
                  }
                }}
                size={{
                  xs: 4
                }}>
                <Grid
                  size={{
                    xs: 6
                  }}>{ detailFormat ? detailFormat(obj) : obj.name }</Grid>
                <Grid
                  size={{
                    xs: 6
                  }}>{ show_image && obj.image_url !== "" && <img src={ obj.image_url } alt={obj.name} style={{ maxHeight: "30px", maxWidth: "30px" }} /> }</Grid>
                { (reasons !== "" || detail !== "") &&
                  <Grid
                    size={{
                      xs: 12
                    }}><span className={ disabled ? "small_label whiteFont" : "small_label gray" }>{ detail }</span>&nbsp;<span className="small_label red">{ reasons }</span></Grid> 
                }
              </Grid>
              <Grid
                size={{
                  xs: 3
                }}>
                <ButtonBox
                  name="Modal"
                  onClick={() => {
                    genLink(obj, "Modal");
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 3
                }}>
                <ButtonBox
                  name="Link"
                  onClick={() => {
                    genLink(obj, "Link");
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 2
                }}>
                <ExpandButton
                  is_expanded={description_for_id === obj._id}
                  onClick={() => { setDescriptionForId(description_for_id === obj._id ? "" : obj._id); }}
                />
              </Grid>
            </Grid>
          </Grid>
          { description_for_id === obj._id &&
            <Grid
              style={{ border: "1px solid", backgroundColor: "black" }}
              size={{
                xs: 12
              }}>
              <DisplayStringWithReplacements display_string={description} />
            </Grid>
          }
          <ToastBox
            openTime={ toast_time }
          >
            Link copied to Clipboard
          </ToastBox>
        </Grid>
      );
    } else if (getLinks) {
      return (
        <Grid container spacing={0} direction="row" className={ disabled ? "padded grayBackground" : cx(classes.root, "padded") }>
          <Grid
            size={{
              xs: 12
            }}>
            <Grid container spacing={0} direction="row" className="whiteFont">
              <Grid
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 4
                }}>
                <Grid
                  size={{
                    xs: 6
                  }}>{ detailFormat ? detailFormat(obj) : obj.name }</Grid>
                <Grid
                  size={{
                    xs: 6
                  }}>{ show_image && obj.image_url !== "" && <img src={ obj.image_url } alt={obj.name} style={{ maxHeight: "30px", maxWidth: "30px" }} /> }</Grid>
                { (reasons !== "" || detail !== "") &&
                  <Grid
                    size={{
                      xs: 12
                    }}><span className={ disabled ? "small_label whiteFont" : "small_label gray" }>{ detail }</span>&nbsp;<span className="small_label red">{ reasons }</span></Grid> 
                }
              </Grid>
              <Grid
                size={{
                  xs: 3
                }}>
                <ButtonBox
                  name="Modal"
                  onClick={() => {
                    genLink(obj, "Modal");
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 3
                }}>
                <ButtonBox
                  name="Link"
                  onClick={() => {
                    genLink(obj, "Link");
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 2
                }}>
                <ExpandButton
                  is_expanded={description_for_id === obj._id}
                  onClick={() => { setDescriptionForId(description_for_id === obj._id ? "" : obj._id); }}
                />
              </Grid>
            </Grid>
          </Grid>
          { description_for_id === obj._id &&
            <Grid
              style={{ border: "1px solid", backgroundColor: "black" }}
              size={{
                xs: 12
              }}>
              <DisplayStringWithReplacements display_string={description} />
            </Grid>
          }
          <ToastBox
            openTime={ toast_time }
          >
            Link copied to Clipboard
          </ToastBox>
        </Grid>
      );
    } else if (onChange && values) {
      return (
        <Grid container spacing={0} direction="row" className={ disabled ? "padded grayBackground" : cx(classes.root, "padded") }>
          <Grid
            size={{
              xs: 12
            }}>
            <Grid container spacing={0} direction="row" className="whiteFont">
              <Grid
                size={{
                  xs: 2
                }}>
                <CheckBox
                  value={values.includes(obj._id)}
                  disabled={disabled}
                  onChange={() => {
                    if (!disabled) {
                      const new_values = values.includes(obj._id) ? [...values.filter(o => o !== obj._id)] : [...values,obj._id];
                      onChange(new_values);
                      setPing(!ping);
                    }
                  }}
                />
              </Grid>
              <Grid
                container
                spacing={0}
                direction="row"
                className={ disabled ? "" : "clickable" }
                onClick={() => {
                  if (!disabled) {
                    const new_values = values.includes(obj._id) ? [...values.filter(o => o !== obj._id)] : [...values,obj._id];
                    onChange(new_values);
                    setPing(!ping);
                  }
                }}
                size={{
                  xs: 6
                }}>
                <Grid
                  size={{
                    xs: 6
                  }}>{ detailFormat ? detailFormat(obj) : obj.name }</Grid>
                <Grid
                  size={{
                    xs: 6
                  }}>{ show_image && obj.image_url !== "" && <img src={ obj.image_url } alt={obj.name} style={{ maxHeight: "30px", maxWidth: "30px" }} /> }</Grid>
                { (reasons !== "" || detail !== "") &&
                  <Grid
                    size={{
                      xs: 12
                    }}><span className={ disabled ? "small_label whiteFont" : "small_label gray" }>{ detail }</span>&nbsp;<span className="small_label red">{ reasons }</span></Grid> 
                }
              </Grid>
              <Grid
                size={{
                  xs: 4
                }}>
                <ExpandButton
                  is_expanded={description_for_id === obj._id}
                  onClick={() => { setDescriptionForId(description_for_id === obj._id ? "" : obj._id); }}
                />
              </Grid>
            </Grid>
          </Grid>
          { description_for_id === obj._id &&
            <Grid
              style={{ border: "1px solid", backgroundColor: "black" }}
              size={{
                xs: 12
              }}>
              <DisplayStringWithReplacements display_string={description} />
            </Grid>
          }
        </Grid>
      );
    }
    return <></>;
  }
  
  if (log_it) {
    debugger;
  }
  if (variants.length === 0) {
    return renderModelBase2({ obj: model_base, disabled_reasons: disableObj ? disableObj(model_base) : { disabled: false, reasons: "" } });
  } else {
    const variant_reasons: { [id: string]: { disabled: boolean , reasons: string } } = {};
    variant_reasons[model_base._id] = disableObj ? disableObj(model_base) : { disabled: false, reasons: "" };
    let all_disabled = variant_reasons[model_base._id].disabled;
    let all_reason = variant_reasons[model_base._id].reasons;
    for (const variant of variants) {
      variant_reasons[variant._id] = disableObj ? disableObj(variant) : { disabled: false, reasons: "" };
      if (all_disabled) {
        if (!variant_reasons[variant._id].disabled) {
          all_disabled = false;
          all_reason = "";
        } else if (all_reason !== "" && variant_reasons[variant._id].reasons !== all_reason) {
          all_reason = ""
        }
      }
    }
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className={cx(classes.root, "padded")}
          onClick={ () => {
            setExpanded(!expanded);
          }}
          size={{
            xs: 12
          }}>
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12
              }}>
              { model_base.use_name }
              <span style={{ 
                fontSize: "10px" 
              }}>&nbsp;Variants: { variants.map(o => o.true_name).join(", ") }</span>
            </Grid>
            { all_disabled &&
              <Grid
                className="small_label red"
                size={{
                  xs: 12
                }}>{ all_reason === "" ? <>All Variants Unavailable</> : all_reason }</Grid>
            }
          </Grid>
        </Grid>
        { expanded &&
          <>
            <Grid
              size={{
                xs: 1
              }}></Grid>
            <Grid
              container
              spacing={0}
              direction="row"
              size={{
                xs: 11
              }}>
              <Grid
                className="padded"
                size={{
                  xs: 12
                }}>{ renderModelBase2({ obj: model_base, disabled_reasons: variant_reasons[model_base._id] }) }</Grid>
              { variants.map(variant => {
                return (
                  <Grid
                    key={variant._id}
                    className="padded"
                    size={{
                      xs: 12
                    }}>{ renderModelBase2({ obj: variant, disabled_reasons: variant_reasons[variant._id] }) }</Grid>
                );
              })}
            </Grid>
          </>
        }
      </Grid>
    );
  }
}